import { HTMLTable } from '@blueprintjs/core';
import { Users } from '@just-in-types';
import * as React from 'react';
import User from '../components/User';
import { firestore } from '../firebase';

interface UsersPageState {
  users: Array<Users.User | Users.UserWithAccount>;
}

class UsersPage extends React.Component<{}, UsersPageState> {
  public state: UsersPageState = { users: [] };

  public componentDidMount() {
    this.watchUsers();
  }

  public render() {
    const { users } = this.state;

    return (
      <div style={{ margin: '0 auto' }} id="user-style">
        <HTMLTable striped={true}>
          <thead>
            <tr>
              <th />
              <th>name</th>
              <th>email</th>
              <th>mobile</th>
              <th>role</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user, index) => (
              <User key={index} user={user} />
            ))}
          </tbody>
        </HTMLTable>
      </div>
    );
  }

  private watchUsers = async () => {
    const query = await firestore
      .collection('users')
      .orderBy('accountData.permissions.role', 'asc')
      .where('hasAccount', '==', true)
      .get();
    const users: Array<Users.User | Users.UserWithAccount> = [];

    query.forEach(doc => {
      const userId = doc.id;
      const userData = doc.data() as Users.User;

      users.push({ userId, ...userData });
    });

    this.setState({ users });
  };
}

export default UsersPage;



// WEBPACK FOOTER //
// ./src/views/Users.tsx